import React from "react";
import IconArrowDown from "../Icons/IconArrowDown";
import "./ShowDetailsButton.scss";

const ShowDetailsButton = ({ onClick }) => (
    <button onClick={onClick} className="show-details-button">
        <div className="text-center thumbarrow-sec">
            {/*
              Downward expand/open arrows. Rendered as CSS-masked spans so the
              red arrow can consume the Appearance Engine token
              (--video-expand-arrow-color). The arrow shape is the alpha channel
              of the original arrow-*.png assets; default color matches the
              legacy PNGs exactly (no visual change).
            */}
            <span
                className="thumbarrow thumbarrow-white"
                role="img"
                aria-label="left-arrow"
            />
            <span
                className="thumbarrow thumbarrow-red"
                role="img"
                aria-label="right-arrow"
            />
        </div>

        {/* <span>
      <IconArrowDown />
    </span> */}
    </button>
);

export default ShowDetailsButton;
